import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-search-result-list/jb-search-result-list.scss?inline
var jb_search_result_list_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.count {
  font-family: var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-regular-weight, 400);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  position: relative;
}

.count {
  font-size: 16px;
  font-size: 1rem;
  line-height: 26px;
  line-height: 1.625rem;
  color: rgba(20, 30, 85, var(--theme-opacity-80, 0.8));
}

.button_wrapper {
  display: flex;
  justify-content: center;
  margin-top: 51px;
}`;

// src/components/jb-search-result-list/jb-search-result-list.ts
var JbSearchResultList = class extends h {
  constructor() {
    super(...arguments);
    this._isLoading = false;
  }
  _loadMore(event) {
    event.preventDefault();
    if (this._isLoading && this.loadMoreUrl) return;
    this.dispatchEvent(
      new CustomEvent("jb-search:loadmore", {
        bubbles: true,
        composed: true
      })
    );
    this._isLoading = true;
    const newArticles = [];
    fetch(this.loadMoreUrl).then((response) => response.json()).then((data) => {
      data.resultSet?.forEach((element) => {
        const articleDate = new Date(element.changed);
        newArticles.push({
          breadcrumbItems: element.breadcrumbs_stringM?.map((breadcrumb) => ({
            text: breadcrumb,
            link: {
              href: "#"
            }
          })),
          category: String(element.factetType).toLocaleLowerCase(),
          date: {
            date: `${articleDate.getDate().toString().padStart(2, "0")}.${(articleDate.getMonth() + 1).toString().padStart(2, "0")}.${articleDate.getFullYear()}`
          },
          headline: element.title,
          previewText: element.teaser,
          link: {
            href: `${window.location.protocol}//${element.site}${element.url}`
          },
          languages: element.availableLanguages?.map((language) => ({
            text: language.twoLetterIsoCode,
            link: {
              data: {
                newsOverlay: {
                  id: language.newsTranslationUid,
                  url: language.newsApiUrl
                }
              }
            }
          }))
        });
      });
      if (data.nextUrl !== "") {
        this.loadMoreUrl = data.nextUrl;
      } else {
        this.buttonLabel = "";
      }
      this.searchResults.push(...newArticles);
      this.resultsVisible = this.searchResults.length;
      this._isLoading = false;
    });
  }
  render() {
    return ke`<div>
      <div class="count">
        ${this.resultCount > 0 ? ke`${this.resultsVisible} ${this.labelOf} ` : D} ${this.resultCount}
        ${this.labelResults}
      </div>
      <div class="list">
        <slot>
          ${this.searchResults.map(
      (item, index) => ke`<jb-search-result-item
                .breadcrumbItems=${item.breadcrumbItems}
                .category=${item.category}
                .date=${item.date}
                .headline=${item.headline}
                .languages=${item.languages}
                .index=${index}
                .link=${item.link}
                >${item.previewText}</jb-search-result-item
              >`
    )}
        </slot>
      </div>
      ${this.buttonLabel && this.resultCount > 0 ? ke`
            <div class="button_wrapper">
              <jb-button
                @click=${this._loadMore}
                .text=${this.buttonLabel}
                .disabled=${this._isLoading}
              ></jb-button>
            </div>
          ` : D}
    </div>`;
  }
};
JbSearchResultList.styles = r(jb_search_result_list_default);
__decorateClass([
  n()
], JbSearchResultList.prototype, "buttonLabel", 2);
__decorateClass([
  n()
], JbSearchResultList.prototype, "labelOf", 2);
__decorateClass([
  n()
], JbSearchResultList.prototype, "labelResults", 2);
__decorateClass([
  n()
], JbSearchResultList.prototype, "loadMoreUrl", 2);
__decorateClass([
  n({ type: Number })
], JbSearchResultList.prototype, "resultCount", 2);
__decorateClass([
  n({ type: Number })
], JbSearchResultList.prototype, "resultsVisible", 2);
__decorateClass([
  n({ type: Array })
], JbSearchResultList.prototype, "searchResults", 2);
__decorateClass([
  r2()
], JbSearchResultList.prototype, "_isLoading", 2);
JbSearchResultList = __decorateClass([
  customElement("jb-search-result-list")
], JbSearchResultList);

export {
  JbSearchResultList
};
